import { TreeNode } from "shared/types/TreeNode"

export function findParent<T>(
  nodes: TreeNode<T>[],
  index: number,
  parentID: string | null | undefined
): {
  parent: TreeNode<T> | null
  index: number
} {
  let parentIndex = index

  if (!parentID) {
    return {
      parent: null,
      index: parentIndex
    }
  }

  for (let i = index - 1; i >= 0; i -= 1) {
    if (nodes[i].id === parentID) {
      parentIndex = i
      break
    }
  }

  return {
    parent: parentIndex === -1 ? null : nodes[parentIndex],
    index: parentIndex
  }
}
